import { render, staticRenderFns } from "./ProformDataHead.vue?vue&type=template&id=04c0000d&scoped=true"
import script from "./ProformDataHead.vue?vue&type=script&lang=js"
export * from "./ProformDataHead.vue?vue&type=script&lang=js"
import style0 from "./ProformDataHead.vue?vue&type=style&index=0&id=04c0000d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0000d",
  null
  
)

export default component.exports